/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReminderSettings
 */
export interface ReminderSettings {
    /**
     * 
     */
    first_reminder_delay_days: number;
    /**
     * 
     */
    repeat_interval_days: number;
    /**
     * 
     */
    max_reminders: number;
    /**
     * Local time in the facility timezone
     */
    send_time: string;
    /**
     * 
     */
    allowed_weekdays: Set<number>;
    /**
     * 
     */
    escalation_delay_days: number;
    /**
     * 
     */
    paused: boolean;
}

/**
 * Check if a given object implements the ReminderSettings interface.
 */
export function instanceOfReminderSettings(value: object): value is ReminderSettings {
    if (!('first_reminder_delay_days' in value) || value['first_reminder_delay_days'] === undefined) return false;
    if (!('repeat_interval_days' in value) || value['repeat_interval_days'] === undefined) return false;
    if (!('max_reminders' in value) || value['max_reminders'] === undefined) return false;
    if (!('send_time' in value) || value['send_time'] === undefined) return false;
    if (!('allowed_weekdays' in value) || value['allowed_weekdays'] === undefined) return false;
    if (!('escalation_delay_days' in value) || value['escalation_delay_days'] === undefined) return false;
    if (!('paused' in value) || value['paused'] === undefined) return false;
    return true;
}

export function ReminderSettingsFromJSON(json: any): ReminderSettings {
    return ReminderSettingsFromJSONTyped(json, false);
}

export function ReminderSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReminderSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'first_reminder_delay_days': json['first_reminder_delay_days'],
        'repeat_interval_days': json['repeat_interval_days'],
        'max_reminders': json['max_reminders'],
        'send_time': json['send_time'],
        'allowed_weekdays': new Set(json['allowed_weekdays']),
        'escalation_delay_days': json['escalation_delay_days'],
        'paused': json['paused'],
    };
}

export function ReminderSettingsToJSON(json: any): ReminderSettings {
    return ReminderSettingsToJSONTyped(json, false);
}

export function ReminderSettingsToJSONTyped(value?: ReminderSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_reminder_delay_days': value['first_reminder_delay_days'],
        'repeat_interval_days': value['repeat_interval_days'],
        'max_reminders': value['max_reminders'],
        'send_time': value['send_time'],
        'allowed_weekdays': Array.from(value['allowed_weekdays'] as Set<any>),
        'escalation_delay_days': value['escalation_delay_days'],
        'paused': value['paused'],
    };
}

